function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 4.08l-7.45 6.774v8.596h4.4V15a1.55 1.55 0 011.55-1.55h3A1.55 1.55 0 0115.05 15v4.45h4.4v-8.596zm-1.043-1.214a1.55 1.55 0 012.085 0l7.5 6.819a1.55 1.55 0 01.508 1.147V19.5a1.55 1.55 0 01-1.55 1.55H15a1.55 1.55 0 01-1.55-1.55v-4.45h-2.9v4.45A1.55 1.55 0 019 21.05H4.5a1.55 1.55 0 01-1.55-1.55v-8.668a1.55 1.55 0 01.507-1.147z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgHouse;